const VERSION = '0.12.1';

export { VERSION as V };
